import { useReact_useEffect_Z101E1A95, useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.1.68.0/React.fs.js";
import { Deferred$1, useFeliz_React__React_useDeferred_Static_2344FC52 } from "../fable_modules/Feliz.UseDeferred.1.5.0/UseDeferred.fs.js";
import { PagingQuery } from "../../../shared/Paging.fs.js";
import { useSnackbar } from "notistack";
import { singleton } from "../fable_modules/fable-library.3.7.17/AsyncBuilder.js";
import { Browser_Types_File__File_ReadAsByteArray } from "../fable_modules/Fable.Remoting.Client.7.25.0/Extensions.fs.js";
import { EnqueueSnackbarOption, SnackbarProp_Variant_Z609E1E86, ProviderContext__enqueueSnackbar_Z1776A768 } from "../../../Notistack/Notistack.fs.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.17/Async.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.17/Choice.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library.3.7.17/List.js";
import { Page$2__toUrl_2B594 } from "../../../BidirectionalRouting/BidirectionalRouting.fs.js";
import { customerDetail, epcCreateFromSibling, dossierCreateFromSibling, dossierDetail } from "../AppRoutes.fs.js";
import { map } from "../fable_modules/fable-library.3.7.17/Option.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogContent from "@material-ui/core/DialogContent";
import { Interop_reactApi } from "../fable_modules/Feliz.1.68.0/./Interop.fs.js";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import { createElement } from "react";
import { DisplayDeferred } from "../../../DesignSystems/DisplayDeferred.fs.js";
import { DossierKind, Compensation_get_DefaultCompensation } from "../../../shared/Domain.fs.js";
import { CreateDossierStepperPage } from "../../../DesignSystems/dossier/DossierCreate.fs.js";
import { createObj, curry } from "../fable_modules/fable-library.3.7.17/Util.js";
import { DossierCreatePageSource } from "../../../DesignSystems/DossierUtils.fs.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Page } from "../components/Page.fs.js";

export function Create(createInputProps) {
    let elements_2, children, children_1, elems_3;
    const siblingSourceCode = createInputProps.siblingSourceCode;
    const kind = createInputProps.kind;
    const api = createInputProps.api;
    const currentPage = createInputProps.currentPage;
    const patternInput = useFeliz_React__React_useState_Static_1505(false);
    const customers = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetCustomers(new PagingQuery(0, 2147483647), void 0), [patternInput[0]]);
    const snackbar = useSnackbar();
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(void 0);
    const setCustomer = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(void 0);
    const compensationAmount = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetCompensationAmount(), []);
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(void 0);
    const setCrossCreate = patternInput_3[1];
    const crossCreate = patternInput_3[0];
    const patternInput_4 = useFeliz_React__React_useState_Static_1505(new Deferred$1(0));
    const setPrefill = patternInput_4[1];
    const uploadFile = (dossierCode, file, endpoint) => singleton.Delay(() => singleton.TryWith(singleton.Delay(() => singleton.Bind(Browser_Types_File__File_ReadAsByteArray(file), (_arg) => singleton.Bind(endpoint(dossierCode)(_arg)(file.name), (_arg_1) => {
        const output = _arg_1;
        if (output.tag === 1) {
            const err = output.fields[0];
            console.error(err);
            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
            return singleton.Zero();
        }
        else {
            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Bestand opgeladen", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
            return singleton.Return();
        }
    }))), (_arg_2) => {
        const e = _arg_2;
        console.error(e);
        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${e.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
        return singleton.Zero();
    }));
    const getCustomer = (customerCode) => {
        startImmediate(singleton.Delay(() => singleton.Bind(api.GetCustomer(customerCode), (_arg_8) => {
            const customer_1 = _arg_8;
            if (customer_1.tag === 1) {
                const err_2 = customer_1.fields[0];
                console.error(err_2);
                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_2}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                return singleton.Zero();
            }
            else {
                setCustomer(customer_1.fields[0]);
                return singleton.Zero();
            }
        })));
    };
    useReact_useEffect_Z101E1A95(() => {
        if (siblingSourceCode != null) {
        }
        else {
            startImmediate(singleton.Delay(() => singleton.Bind(api.GetCustomerOfPartner(), (_arg_11) => {
                const customer_3 = _arg_11;
                if (customer_3.tag === 1) {
                    const err_4 = customer_3.fields[0];
                    console.error(err_4);
                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_4}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                    return singleton.Zero();
                }
                else {
                    const customer_4 = customer_3.fields[0];
                    patternInput_2[1](customer_4);
                    setCustomer(customer_4);
                    return singleton.Zero();
                }
            })));
        }
    }, []);
    useReact_useEffect_Z101E1A95(() => {
        if (siblingSourceCode != null) {
            const sourceCode = siblingSourceCode;
            startImmediate(singleton.Delay(() => {
                setPrefill(new Deferred$1(1));
                return singleton.TryWith(singleton.Delay(() => singleton.Bind(api.GetSiblingDossierDraft(sourceCode, kind), (_arg_12) => {
                    const result_2 = _arg_12;
                    if (result_2.tag === 1) {
                        const err_5 = result_2.fields[0];
                        console.error(err_5);
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Kon gekoppeld dossier niet voorbereiden: ${err_5}`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                        setPrefill(new Deferred$1(2, new FSharpResult$2(1, err_5)));
                        return singleton.Zero();
                    }
                    else {
                        setCustomer(result_2.fields[0][1]);
                        setPrefill(new Deferred$1(2, new FSharpResult$2(0, result_2.fields[0])));
                        return singleton.Zero();
                    }
                })), (_arg_13) => {
                    const e_3 = _arg_13;
                    console.error(e_3);
                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${e_3.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                    setPrefill(new Deferred$1(2, new FSharpResult$2(1, e_3.message)));
                    return singleton.Zero();
                });
            }));
        }
    }, [siblingSourceCode]);
    const title = (kind.tag === 1) ? "Nieuw EPC aanmaken" : "Nieuw dossier aanmaken";
    const dismissSibling = () => {
        if (crossCreate == null) {
            setCrossCreate(void 0);
        }
        else {
            const dossierCode_2 = crossCreate[0];
            setCrossCreate(void 0);
            RouterModule_nav(ofArray(Page$2__toUrl_2B594(dossierDetail, dossierCode_2.Value)), 1, 1);
        }
    };
    let crossCreateModal;
    const isOpen = crossCreate != null;
    const siblingKind_2 = map((tuple) => tuple[1], crossCreate);
    const promptMessage = (siblingKind_2 == null) ? "" : ((siblingKind_2.tag === 0) ? "Wil je voor dit dossier ook een asbestattest opstarten?" : "Wil je voor dit dossier ook een EPC opstarten?");
    crossCreateModal = MuiHelpers_createElement(Dialog, [["open", isOpen], ["onClose", (_arg_15, v) => {
        dismissSibling();
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", "Gekoppeld dossier"]]), (children = singleton_1(MuiHelpers_createElement(DialogContentText, [["children", promptMessage]])), MuiHelpers_createElement(DialogContent, [["children", Interop_reactApi.Children.toArray(Array.from(children))]])), (children_1 = ofArray([MuiHelpers_createElement(Button, [["color", "default"], ["onClick", (_arg_16) => {
        dismissSibling();
    }], ["children", "Nee"]]), MuiHelpers_createElement(Button, [["color", "primary"], ["variant", "contained"], ["onClick", (_arg_17) => {
        if (crossCreate != null) {
            const siblingKind_1 = crossCreate[1];
            const dossierCode_3 = crossCreate[0];
            setCrossCreate(void 0);
            RouterModule_nav(ofArray((siblingKind_1.tag === 0) ? Page$2__toUrl_2B594(dossierCreateFromSibling, dossierCode_3.Value) : Page$2__toUrl_2B594(epcCreateFromSibling, dossierCode_3.Value)), 1, 1);
        }
    }], ["children", "Ja"]])]), MuiHelpers_createElement(DialogActions, [["children", Interop_reactApi.Children.toArray(Array.from(children_1))]]))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])]);
    const stepperBody = (prefillValue) => createElement(DisplayDeferred, {
        data: compensationAmount,
        view: (compensationAmt) => {
            const compAmt = (compensationAmt == null) ? Compensation_get_DefaultCompensation() : compensationAmt;
            return createElement(CreateDossierStepperPage, {
                customerUrl: (arg_7) => Page$2__toUrl_2B594(customerDetail, arg_7),
                getCustomer: getCustomer,
                customers: customers,
                onCreateDossier: (dossierData) => ((comment) => ((floorplan) => ((cadastralRecords) => ((propertyOtrher) => ((sendMailToPartner) => ((onCompleted) => {
                    startImmediate(singleton.Delay(() => singleton.TryFinally(singleton.Delay(() => singleton.TryWith(singleton.Delay(() => singleton.Bind(api.CreateDossier(dossierData, comment), (_arg_3) => {
                        let floorplan_1;
                        const result = _arg_3;
                        if (result.tag === 0) {
                            const dossierCode_1 = result.fields[0];
                            return singleton.Combine((floorplan == null) ? ((singleton.Zero())) : ((floorplan_1 = floorplan, singleton.Bind(uploadFile(dossierCode_1, floorplan_1, curry(3, api.UploadFloorplan)), () => singleton.Return()))), singleton.Delay(() => {
                                let cadastralRecords_1;
                                return singleton.Combine((cadastralRecords == null) ? ((singleton.Zero())) : ((cadastralRecords_1 = cadastralRecords, singleton.Bind(uploadFile(dossierCode_1, cadastralRecords_1, curry(3, api.UploadCadastralRecords)), () => singleton.Return()))), singleton.Delay(() => {
                                    let propertyOtrher_1;
                                    return singleton.Combine((propertyOtrher == null) ? ((singleton.Zero())) : ((propertyOtrher_1 = propertyOtrher, singleton.Bind(uploadFile(dossierCode_1, propertyOtrher_1, curry(3, api.UploadPropertyOther)), () => singleton.Return()))), singleton.Delay(() => {
                                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Een nieuw dossier is aangemaakt", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                                        if (siblingSourceCode == null) {
                                            setCrossCreate([dossierCode_1, (kind.tag === 1) ? (new DossierKind(0)) : (new DossierKind(1))]);
                                            return singleton.Zero();
                                        }
                                        else {
                                            RouterModule_nav(ofArray(Page$2__toUrl_2B594(dossierDetail, dossierCode_1.Value)), 1, 1);
                                            return singleton.Zero();
                                        }
                                    }));
                                }));
                            }));
                        }
                        else {
                            const err_1 = result.fields[0];
                            console.error(err_1);
                            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_1}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, true));
                            return singleton.Zero();
                        }
                    })), (_arg_7) => {
                        const e_1 = _arg_7;
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${e_1.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, true));
                        console.error(e_1);
                        return singleton.Zero();
                    })), () => {
                        onCompleted();
                    })));
                })))))),
                onCreateCustomer: (customerData) => ((onCompleted_1) => {
                    startImmediate(singleton.Delay(() => singleton.TryFinally(singleton.Delay(() => singleton.TryWith(singleton.Delay(() => singleton.Bind(api.CreateCustomer(customerData), (_arg_9) => {
                        const result_1 = _arg_9;
                        if (result_1.tag === 0) {
                            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Een nieuwe klant is aangemaakt", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                            getCustomer(result_1.fields[0].Code);
                            return singleton.Zero();
                        }
                        else {
                            const err_3 = result_1.fields[0];
                            console.error(err_3);
                            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_3}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                            return singleton.Zero();
                        }
                    })), (_arg_10) => {
                        const e_2 = _arg_10;
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${e_2.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                        console.error(e_2);
                        return singleton.Zero();
                    })), () => {
                        onCompleted_1();
                    })));
                }),
                customer: patternInput_1[0],
                setCustomer: setCustomer,
                partnersList: void 0,
                setPartnerId: void 0,
                dossierCreatePageSource: new DossierCreatePageSource(1),
                compensation: compAmt,
                kind: kind,
                prefill: prefillValue,
            });
        },
    });
    let body;
    const matchValue = [siblingSourceCode, patternInput_4[0]];
    let pattern_matching_result, draft_1;
    if (matchValue[0] != null) {
        if (matchValue[1].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[1].tag === 2) {
            if (matchValue[1].fields[0].tag === 1) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 2;
                draft_1 = matchValue[1].fields[0].fields[0];
            }
        }
        else if (matchValue[1].tag === 3) {
            pattern_matching_result = 4;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            body = stepperBody(void 0);
            break;
        }
        case 1: {
            body = createElement("div", createObj(ofArray([["style", {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 4 + "rem",
            }], (elems_3 = [MuiHelpers_createElement(CircularProgress, [])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
            break;
        }
        case 2: {
            body = stepperBody(draft_1);
            break;
        }
        case 3: {
            body = stepperBody(void 0);
            break;
        }
        case 4: {
            body = stepperBody(void 0);
            break;
        }
    }
    return createElement(Page, {
        currentPage: currentPage,
        title: title,
        actions: [],
        children: [body, crossCreateModal],
    });
}

